import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

export const GridItem = styled(Grid, {
  name: 'GridItem',
})(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.secondary.main}`,
}));
